import { Link, Outlet, useNavigate } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { useEffect, useState } from "react";
import "../styles/Navigation.css";

const HomeAdmin = () => {
  const [userName, setUserName] = useState("");
  const [expanded, setExpanded] = useState(false); // 👈 control collapse
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem("username");
    if (userData) {
      setUserName(userData);
    } else {
      navigate("/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("admin_id");
    navigate("/login_admin");
  };

  const handleNavClick = () => {
    setExpanded(false); // 👈 collapse menu on link click
  };

  return (
    <>
      <img
        src="/images/banner_2.png"
        className="banner-img"
        alt="Company Banner"
      />

      <Navbar
        bg="dark"
        variant="dark"
        expand="lg"
        className="custom-navbar"
        expanded={expanded}
        onToggle={(val) => setExpanded(val)}
      >
        <Container>
          <Navbar.Brand as={Link} to="." className="brand-logo">
            <img
              src="/images/logo1.png"
              width="50"
              height="50"
              className="logo-img"
              alt="Company Logo"
            />
            <span className="company-name">SAL PITA</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto nav-links">
              <Nav.Link as={Link} to="." onClick={handleNavClick}>Home</Nav.Link>
              <Nav.Link as={Link} to="manageCustomers" onClick={handleNavClick}>Manage Customers</Nav.Link>
              <Nav.Link as={Link} to="manageOrders" onClick={handleNavClick}>Manage Order</Nav.Link>
              <Nav.Link as={Link} to="managePayments" onClick={handleNavClick}>Manage Payments</Nav.Link>
              <Nav.Link as={Link} to="manageBread" onClick={handleNavClick}>Manage Bread Price</Nav.Link>

              <NavDropdown title="Reports" id="reports-dropdown">
                <NavDropdown.Item as={Link} to="reports/sales" onClick={handleNavClick}>Sales Report</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="reports/orders" onClick={handleNavClick}>Order Report</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="reports/customers" onClick={handleNavClick}>Customer Report</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="customers/blocked" onClick={handleNavClick}>Blocked Customer Report</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="customers/fail" onClick={handleNavClick}>Login Failed Report</NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={Link} to="profile" onClick={handleNavClick}>Update Profile</Nav.Link>
              <Nav.Link onClick={() => { handleLogout(); handleNavClick(); }}>Logout</Nav.Link>
            </Nav>

            <span className="text-white ms-auto me-3">
              Welcome, {userName}
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Outlet />
    </>
  );
};

export default HomeAdmin;
